<div
    class="cmps-drawer right"
    [cmps-drawer]="drawerOptions"
    [(open)]="open"
>
    <div class="cmps-drawer-contents">
        <cmps-wait-status
            [absolute]="true"
            *ngIf="hasPendingData"
        ></cmps-wait-status>
        <div
            id="notificationPanel"
            tabindex="-1"
            role="region"
            [attr.aria-label]="'Notification Panel' | translate"
            [attr.aria-busy]="hasPendingData"
        >
            <ng-container
                *ngIf="
                    !hasPendingData &&
                    categories != null &&
                    notifications != null
                "
            >
                <button
                    type="button"
                    class="close ml-3"
                    [attr.aria-label]="i18n._763_CLOSE | translate"
                    (click)="open = false"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
                <ngb-tabset>
                    <ngb-tab [title]="i18n._109_ALL | translate">
                        <ng-template ngbTabContent>
                            <div
                                tabindex="0"
                                role="application"
                                [attr.aria-label]="i18n._109_ALL | translate"
                            >
                                <div
                                    class="text-center"
                                    *ngIf="notifications.length === 0"
                                >
                                    {{ i18n._110_NOTHING_HERE | translate }}
                                </div>
                                <ng-container
                                    *ngFor="let n of notifications; index as nn"
                                >
                                    <cmps-notification
                                        [notification]="n"
                                        [index]="nn"
                                        (dismiss)="
                                            onNotificationDismiss($event)
                                        "
                                    ></cmps-notification>
                                </ng-container>
                            </div>
                        </ng-template>
                    </ngb-tab>
                    <ng-template
                        ngFor
                        let-c
                        [ngForOf]="categories"
                    >
                        <ngb-tab>
                            <ng-template ngbTabTitle>
                                <span>{{ c.defaultName }}</span>
                                <span
                                    class="badge badge-pill badge-danger"
                                    *ngIf="
                                        c.id ===
                                            _NotificationCategoryList.ALERT &&
                                        _unreadAlertCount > 0
                                    "
                                    >{{ _unreadAlertCount }}</span
                                >
                            </ng-template>

                            <ng-template ngbTabContent>
                                <div
                                    tabindex="0"
                                    role="application"
                                    [attr.aria-label]="c.defaultName"
                                >
                                    <div
                                        class="text-center"
                                        *ngIf="categoryCount[c.id] == null"
                                    >
                                        {{ i18n._110_NOTHING_HERE | translate }}
                                    </div>
                                    <ng-container
                                        *ngFor="
                                            let n of notifications;
                                            index as nn
                                        "
                                    >
                                        <cmps-notification
                                            [notification]="n"
                                            [index]="nn"
                                            (dismiss)="
                                                onNotificationDismiss($event)
                                            "
                                            *ngIf="n.categoryId === c.id"
                                        ></cmps-notification>
                                    </ng-container>
                                </div>
                            </ng-template>
                        </ngb-tab>
                    </ng-template>
                </ngb-tabset>
            </ng-container>
        </div>
    </div>
</div>
